import React, { useState, useEffect } from 'react';
import './AnimatedModal.css';
import ReactDOM from 'react-dom';

const AnimatedModal = (props) => {
  const { isOpen, children, layout } = props;
  const [modalVisible, setModalVisible] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setModalVisible(true);
      document.documentElement.style.overflow = 'hidden';
    } else {
      setClosing(true);
      setTimeout(() => {
        setModalVisible(false);
        setClosing(false);
        document.documentElement.removeAttribute('style');
      }, 300);
    }
  }, [isOpen]);

  if (!modalVisible) {
    return null;
  }

  return ReactDOM.createPortal(
    <React.Fragment>
      <style>{`.swiper{ height: 100%; width: 100%}
      `}</style>
      <idk-div
        class={`modal-overlay ${layout?.gallerySettings?.modalDesign === 'square' ? 'modal-white-overlay' : ''} ${
          closing ? 'closing' : ''
        }`}
      >
        <idk-div
          id="idk_modal_container"
          class={`idukki-modal-portal ${closing ? 'slide-out' : 'slide-in'} ${
            layout?.gallerySettings?.modalDesign === 'inspiration' ? 'zid-h-full' : ''
          }`}
          style={{ width: '100%' }}
        >
          {children}
        </idk-div>
      </idk-div>
    </React.Fragment>,
    document.body,
  );
};

export default AnimatedModal;
